import React from "react";

export let HeadingPlaceholder = () => <div className={"placeholder-glow"}>
    <div className="placeholder w-100">
    </div>
</div>

export let Paragraph1Placeholder = () => <>
    <span className="placeholder placeholder-sm col-7 me-2"></span>
    <span className="placeholder placeholder-sm col-4"></span>
    <span className="placeholder placeholder-sm col-4 me-2"></span>
    <span className="placeholder placeholder-sm col-6"></span>
    <span className="placeholder placeholder-sm col-8"></span>
</>

export let Paragraph2Placeholder = () => <>
    <span className="placeholder placeholder-sm col-8"></span>
    <span className="placeholder placeholder-sm col-4 me-2"></span>
    <span className="placeholder placeholder-sm col-7"></span>
    <span className="placeholder placeholder-sm col-6 me-2"></span>
    <span className="placeholder placeholder-sm col-4"></span>
    <span className="placeholder placeholder-sm col-5"></span>
</>

export let Paragraph3Placeholder = () => <>
    <span className="placeholder placeholder-sm col-7"></span>
    <span className="placeholder placeholder-sm col-6 me-2"></span>
    <span className="placeholder placeholder-sm col-2"></span>
</>

export let MultipleParagraphsPlaceholder = () => <>
    <div className={"mb-3"}>
        <Paragraph1Placeholder/>
    </div>
    <div className={"mb-3"}>
        <Paragraph2Placeholder/>
    </div>
    <Paragraph3Placeholder/>
</>

export let PlaceholderImage = () => {
    return <div className="position-relative placeholder-wave">
        <div className="card-img-top placeholder ratio ratio-16x9"></div>
        <i className="ai-image position-absolute top-50 start-50 translate-middle fs-1"></i>
    </div>
}